import PaperTable from '../components/PaperTable';
import './Pages.css';

function PaperDatabasePage() {
  return (
    <div className='page-container'>
      <PaperTable />
    </div>
  );
}

export default PaperDatabasePage;